import { Map } from 'immutable'
import { EN } from 'services/languages/constants'
import { getUserLanguagePrimary } from 'services/user'
import { GET_PM_MULTIPLE_TERMS } from './actions'
import { getMultipleTerms } from './watchers-helpers'

function fetchMultipleTerms ({ after }) {
  return after(GET_PM_MULTIPLE_TERMS, async ({ action, state, dispatch }) => {
    const { user = Map(), auth = Map() } = state
    const language = getUserLanguagePrimary(user) || EN
    const { payload: { termIds } } = action
    await getMultipleTerms({
      dispatch,
      language,
      termIds,
      auth,
    })
  })
}

export default fetchMultipleTerms
